import { useMemo } from "react";
import { Endpoints, queryKeys } from "../api";
import { useAuth, useProfile } from "../contexts";
import { useAxios, useGenericQuery } from "../hooks";
import { Territory, IUseQueryPaged } from "../models";

interface TerritoryQuery extends Pick<IUseQueryPaged<Territory>, "listQuery"> {}

export const useTerritoryQuery = (): TerritoryQuery => {
    const { isAuthorized } = useAuth();
    const { currentUser } = useProfile();
    const { get } = useAxios();
    const url = Endpoints.Territories;

    const listQuery = useGenericQuery({
        queryFn: (config) => get<Territory[]>({ url, config }),
        queryKey: queryKeys.territories.list(),
        placeholderData: [],
        enabled: isAuthorized && !!currentUser,
        cacheTime: 1000 * 60 * 60 * 24,
        staleTime: 1000 * 60 * 60 * 24,
    });

    return useMemo<TerritoryQuery>(
        () => ({
            listQuery,
        }),
        [listQuery]
    );
};
